import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Iletisim.css';

const Iletisim = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    ad: '',
    telefon: '',
    email: '',
    konu: '',
    mesaj: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await fetch('/send_email.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (result.status === 'success') {
        setMessage({ type: 'success', text: result.message });
        setFormData({
          ad: '',
          telefon: '',
          email: '',
          konu: '',
          mesaj: ''
        });
      } else {
        setMessage({ type: 'error', text: result.message });
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Bir hata oluştu. Lütfen tekrar deneyin.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="iletisim-page">
      {/* Header */}
      <header className="main-header">
        <div className="header-container">
          <Link to="/" className="header-logo">
            <img src="/images/logo.png" alt="Logo" />
            <div className="header-logo-text">
              <span className="logo-main">DİGİTALENTRA</span>
              <span className="logo-sub">Software</span>
            </div>
          </Link>
          
          <button 
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Menu"
          >
            <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>

          <nav className="nav-menu desktop-only">
            <ul>
              <li><Link to="/">Ana Sayfa</Link></li>
              <li><Link to="/hizmetlerimiz">Hizmetler</Link></li>
              <li><Link to="/projelerimiz">Projelerimiz</Link></li>
              <li><Link to="/iletisim" className="active">İletişim</Link></li>
            </ul>
          </nav>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-fullscreen">
          <button 
            className="mobile-menu-close"
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Close Menu"
          >
            <span className="close-icon">
              <span></span>
              <span></span>
            </span>
          </button>
          <nav className="mobile-nav">
            <ul>
              <li><Link to="/" onClick={() => setIsMobileMenuOpen(false)}>Ana Sayfa</Link></li>
              <li><Link to="/hizmetlerimiz" onClick={() => setIsMobileMenuOpen(false)}>Hizmetler</Link></li>
              <li><Link to="/projelerimiz" onClick={() => setIsMobileMenuOpen(false)}>Projelerimiz</Link></li>
              <li><Link to="/iletisim" onClick={() => setIsMobileMenuOpen(false)}>İletişim</Link></li>
            </ul>
          </nav>
        </div>
      )}

      <div className="iletisim-hero">
        <h1 className="iletisim-title">İletişime Geçin</h1>
        <p className="iletisim-subtitle">
          Projeleriniz için bizimle iletişime geçin, size en kısa sürede dönüş yapalım
        </p>
      </div>

      <div className="iletisim-container">
        <div className="iletisim-content">
          {/* Contact Form */}
          <div className="contact-form-section">
            <h2>Mesaj Gönderin</h2>
            <form className="contact-form" onSubmit={handleSubmit}>
              {message.text && (
                <div className={`form-message ${message.type}`}>
                  {message.text}
                </div>
              )}

              <div className="form-group">
                <input 
                  type="text" 
                  name="ad"
                  className="form-input" 
                  placeholder="Adınız"
                  value={formData.ad}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <input 
                  type="tel" 
                  name="telefon"
                  className="form-input" 
                  placeholder="Telefon Numaranız"
                  value={formData.telefon}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <input 
                  type="email" 
                  name="email"
                  className="form-input" 
                  placeholder="E-posta Adresiniz"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <input 
                  type="text" 
                  name="konu"
                  className="form-input" 
                  placeholder="Konu"
                  value={formData.konu}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <textarea 
                  name="mesaj"
                  className="form-input form-textarea" 
                  placeholder="Mesajınız"
                  rows="6"
                  value={formData.mesaj}
                  onChange={handleInputChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="form-submit-btn" disabled={isSubmitting}>
                {isSubmitting ? 'GÖNDERİLİYOR...' : 'GÖNDER'}
              </button>
            </form>
          </div>

          {/* Contact Info */}
          <div className="contact-info-section">
            <h2>İletişim Bilgileri</h2>
            
            <div className="info-card">
              <div className="info-icon">📧</div>
              <div className="info-content">
                <h3>E-posta</h3>
                <a href="mailto:info@digitalentrasoftware.com">info@digitalentrasoftware.com</a>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">📱</div>
              <div className="info-content">
                <h3>Telefon</h3>
                <a href="tel:+905318287339">0531 828 7339</a>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">📍</div>
              <div className="info-content">
                <h3>Adres</h3>
                <p>Tekirdağ/Çorlu</p>
              </div>
            </div>

            <div className="social-links">
              <h3>Sosyal Medya</h3>
              <div className="social-buttons">
                <a href="https://www.instagram.com/digitalentrasoftware/" target="_blank" rel="noopener noreferrer" className="social-btn instagram">
                  Instagram
                </a>
                <a href="https://wa.me/905318287339" target="_blank" rel="noopener noreferrer" className="social-btn whatsapp">
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <img src="/images/logo.png" alt="Logo" />
                <span>Digitalentra</span>
              </div>
              <p className="footer-description">
                Modern web siteleri, mobil uygulamalar ve yazılım çözümleri ile işletmenizi dijital dünyaya taşıyoruz.
              </p>
            </div>

            <div className="footer-section">
              <h3 className="footer-title">Hızlı Linkler</h3>
              <ul className="footer-links">
                <li><Link to="/">Ana Sayfa</Link></li>
                <li><Link to="/hizmetlerimiz">Hizmetler</Link></li>
                <li><Link to="/projelerimiz">Projelerimiz</Link></li>
                <li><Link to="/iletisim">İletişim</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3 className="footer-title">Hizmetlerimiz</h3>
              <ul className="footer-links">
                <li><Link to="/hizmetlerimiz">Web Geliştirme</Link></li>
                <li><Link to="/hizmetlerimiz">Mobil Uygulama</Link></li>
                <li><Link to="/hizmetlerimiz">Backend Geliştirme</Link></li>
                <li><Link to="/hizmetlerimiz">Bulut Çözümleri</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3 className="footer-title">İletişim</h3>
              <ul className="footer-contact">
                <li>📧 <a href="mailto:info@digitalentrasoftware.com">info@digitalentrasoftware.com</a></li>
                <li>📱 <a href="tel:+905318287339">0531 828 7339</a></li>
                <li>📍 Tekirdağ/Çorlu</li>
              </ul>
              <div className="footer-social">
                <a href="https://www.instagram.com/digitalentrasoftware/" target="_blank" rel="noopener noreferrer" className="social-link">
                  Instagram
                </a>
                <a href="https://wa.me/905318287339" target="_blank" rel="noopener noreferrer" className="social-link social-whatsapp">
                  WhatsApp
                </a>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2025 Digitalentra Software. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>

      {/* Floating Buttons */}
      <div className="floating-buttons">
        <a 
          href="https://wa.me/905318287339" 
          target="_blank" 
          rel="noopener noreferrer"
          className="floating-btn whatsapp-btn"
          aria-label="WhatsApp"
        >
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
          </svg>
        </a>
      </div>
    </div>
  );
};

export default Iletisim;
